// [AUDIT-2026-10-21 PWD-8] The server's password rule
// (backend/security.validate_password_strength: 8 to 72 characters), checked
// again here so a form can say so before the request. Five screens checked
// for 6: a 6- or 7-character password passed the form and was then refused.
export const MIN_PASSWORD_LENGTH = 8;
